/* unplugin-vue-components disabled */import { render } from "./buy.vue?vue&type=template&id=4518eb97&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"

import "./buy.vue?vue&type=style&index=0&id=4518eb97&scoped=true&lang=css"

import exportComponent from "D:\\PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4518eb97"]])

export default __exports__